import axios from "axios";

const viacepInstance = axios.create({
  baseURL: "https://viacep.com.br/ws/",
  headers: {
    "Content-Type": "application/json"
  }
});

export { viacepInstance };
